<template>
  <section class="style-section">
    <div class="title-guide">获取安装包</div>
    <div class="content-guide">可以通过一下两种方式获取软件：</div>
    <div class="content-guide">
      1.关注“唯奥衡卓”微信公众号，在公众号内“软件获取”——“我要软件”，
      输入邮箱号确认后即可在该邮箱内收取到包含软件初始安装包的邮件。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 200px" :src="url1" :fit="fit" />
      </div>
      <div class="title-img">微信公众号</div>
    </div>
    <div class="content-guide">
      2.申请加入唯奥衡卓QQ普通会员群：693685140，申请信息请填“Midas”，
      通过后即可在群文件中下载软件初始安装包。程序使用中出现的问题也可以咨询群内技术支持。
    </div>
    <div class="content-guide" style="font-weight: 600;">注：关注“唯奥衡卓”微信公众号后将立刻取得7日软件试用权限，
      可在接下来的7天内微信扫码登录程序免费试用“装配式结构单梁模块”。</div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">安装软件</div>
    <div class="content-guide">
      解压安装包后，双击setup.exe进行安装。
      程序安装完成后会自动升级到最新版本（程序每次运行时都会先检测是否有最新版本，如果有就会自动升级）。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 600px; height: 90px" :src="url2" :fit="fit" />
      </div>
    </div>
    <div class="content-guide">
      由于程序需要自动升级，考虑到系统权限问题，
      故建议程序不要安装在系统盘中，否则容易出现升级出错或者使用时文件读取错误的问题。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 500px; height: 300px" :src="url3" :fit="fit" />
      </div>
    </div>
    <li class="content-guide" style="font-weight: 600;">注意事项： 软件安装需要.net framework 4.0支持。</li>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">运行软件</div>
    <div class="content-guide">
      双击桌面的软件图标，会出现带二维码的登录窗体。
      使用关注过“唯奥衡卓”微信公众号的微信号扫码后即可进入程序模块选择界面。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 592px; height: 280px" :src="url4" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/install-1.jpg"),
      url2: require("@/assets/png/install-2.png"),
      url3: require("@/assets/png/install-3.png"),
      url4: require("@/assets/png/install-4.png"),
      fit: "fill",
    };
  },
};
</script>
